import type { ClientStorageItem } from '@/shared/api/clientStorage';

import { useMutation } from '@tanstack/react-query';

import { API } from '@/shared/api';
import { queryClient } from '@/shared/config';

import { CLIENT_STORAGE_QUERY_KEYS } from '../lib/constants';

type SetClientStorageItemParams = {
  key: string;
  value: string;
};

export const useSetClientStorageItem = () => {
  return useMutation({
    mutationFn: ({ key, value }: SetClientStorageItemParams) => API.setItem(key, value),
    mutationKey: CLIENT_STORAGE_QUERY_KEYS.setItem,
    onSuccess: (data: ClientStorageItem) => {
      queryClient.setQueryData(CLIENT_STORAGE_QUERY_KEYS.item(data.key), data);
      void queryClient.invalidateQueries({ queryKey: CLIENT_STORAGE_QUERY_KEYS.list });
    },
  });
};
